import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { UT_TABS } from './navItems';

/** Mobile bottom tab bar (below 834px): a 22×3 indicator over a condensed label. */
export const UtBottomTabs: React.FC = () => {
  const { pathname, search } = useLocation();
  return (
    <nav
      aria-label="Main"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-5 border-t border-ut-line bg-ut-bg2 px-1.5 pb-[max(10px,env(safe-area-inset-bottom))] pt-1.5 ut-md:hidden"
    >
      {UT_TABS.map((t) => {
        const active = t.match(pathname, search);
        return (
          <Link
            key={t.key}
            to={t.to}
            aria-current={active ? 'page' : undefined}
            className={clsx('flex min-h-[44px] flex-col items-center gap-[5px] py-2', active ? 'text-ut-acc' : 'text-ut-mut')}
          >
            <span className={clsx('h-[3px] w-[22px] rounded-sm', active ? 'bg-ut-acc' : 'bg-transparent')} />
            <span className="font-ut-display text-sm font-bold uppercase tracking-[0.08em]">{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};
